export default "__VITE_ASSET__D5$9e$ac__"